/**
 * Extract a user-facing message from an axios (or similar) error.
 * When CORS blocks a response, axios only exposes error.message ("Network Error").
 */
export const getApiErrorMessage = (
  error,
  fallback = 'Something went wrong. Please try again.'
) => {
  const data = error?.response?.data;
  if (typeof data?.message === 'string' && data.message) return data.message;
  if (typeof data?.error?.message === 'string' && data.error.message) return data.error.message;
  if (error?.message && error.message !== 'Network Error') return error.message;
  if (error?.message === 'Network Error') {
    return 'Unable to reach the server. Check your connection or try again in a few minutes.';
  }
  return fallback;
};
